<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const items = Array.isArray(props.items) ? props.items : [];
    const ordered = Boolean(props.ordered);
    const listTag = ordered ? 'ol' : 'ul';
    const color = styleOrEmpty(props.color, 'color');
    const fontSize = styleOrEmpty(props.fontSize, 'font-size');
    const fontFamily = styleOrEmpty(props.fontFamily, 'font-family');
    const lineHeight = styleOrEmpty(props.lineHeight, 'line-height');
    const align = styleOrEmpty(props.align, 'text-align');
    const padding = styleOrEmpty(props.padding, 'padding');
    const listStyleType = styleOrEmpty(
        props.listStyleType || (ordered ? 'decimal' : 'disc'),
        'list-style-type'
    );
    const listStylePosition = styleOrEmpty(props.listStylePosition, 'list-style-position');
    const listItems = items.map((item) => `<li>${item}</li>`).join('');

    return `<${listTag} style="margin:0;${color}${fontSize}${fontFamily}${lineHeight}${align}${padding}${listStyleType}${listStylePosition}">${listItems}</${listTag}>`;
};

export default {
    name: 'MailingBlockList',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
